module.exports = __webpack_public_path__ + "static/media/image-01.ddd88e04.svg";